import React from "react"
import { Link } from "gatsby"

export default function BlogCategories({ post }) {
  //   const cats = post.storyCategorys.nodes.map(item => item.name).join()
  return (
    <p className={"mt-4 text-sm text-center md:text-left"}>
      <span className={"mr-4"}>Posted In:</span>
      {post.categories.nodes.map(item => (
        <Link
          key={`${item.slug}`}
          to={`/${item.slug}/`}
          className={"font-bold mr-4"}
        >
          {item.name}
        </Link>
      ))}
    </p>
  )
}
